import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Injector, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/app-component-base';
import { ChatMensagemDto, ChatNotificacaoServiceProxy, ChatServiceServiceProxy, NewChatInformationsDto } from '@shared/service-proxies/service-proxies';
import { finalize } from 'rxjs/operators';
import { ChatService } from '@shared/services/chat.service';
import { ChatMessagesComponent } from './chat-messages/chat-messages.component';
import { NewMessageDto } from '@shared/model/new-message';
import { chatUserName } from '@shared/model/chat-user.model';
import { UserNotification } from '@shared/model/user-notification';
import * as moment from 'moment';
@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  animations: [appModuleAnimation()],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ChatComponent extends AppComponentBase implements OnInit {
  destinatarioId: number;
  equipeId: string;
  chatMensagens: ChatMensagemDto[] = [];
  mensagem: string;
  equipes: NewChatInformationsDto[] = [];
  conversas: chatUserName[] = [];
  notificacoes: UserNotification[] = [];
  novosChatsUserId: string[] = [];

  static atualizarNotificacoes = new EventEmitter<any>();

  eventRolarMensagensSubject: Subject<void> = new Subject<void>();

  constructor(
    injector: Injector,
    private _chatService: ChatServiceServiceProxy,
    private _notificacaoService: ChatNotificacaoServiceProxy,
    private cdr: ChangeDetectorRef,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    abp.ui.setBusy();

    this.getNewChatsUserId();
    this.getNotificacoesUsuario();
    this._chatService
      .getEquipesToChat(this.appSession.clinicaId, this.appSession.profissionalId)
      .pipe(
        finalize(() => abp.ui.clearBusy())
      )
      .subscribe((result) => {
        this.equipes = result;
        this.equipes.map((equipe) => {
          let conversa: chatUserName = {
            equipeId: equipe.equipeId,
            name: equipe.nomeEquipe,
            profissionaisNames: equipe.profisionais,
            lastRemetenteId: equipe.userIdUltimaMensagem,
            dataHora: equipe.dataHota,
            ultimaMensagem: equipe.ultimaMensagem,
            clinica: equipe.clinicaNome
          };
          this.conversas.push(conversa);
          this.cdr.markForCheck();
        });
        this.equipeId = this.conversas[0].equipeId;
        this.obterMensagens(this.equipeId, this.conversas[0].lastRemetenteId);
      });

    ChatComponent.atualizarNotificacoes.emit();

    ChatService.atualizarConversa.asObservable().subscribe((result: NewMessageDto) => {
      if (this.equipeId == result.equipeId) this.obterMensagens(result.equipeId, result.remetenteId);
      if (result.remetenteId != this.appSession.userId) this.atualizarUltimoRementente(result)
    });

    ChatMessagesComponent.atualizarChat.asObservable().subscribe((result) => {
      this.obterMensagens(result.equipeId)
      this.atualizarUltimoRementente(result);
    });
  }

  obterMensagens(equipeId: string, remetenteId: number = null) {
    this.equipeId = equipeId;
    abp.ui.setBusy();
    this._chatService
      .getChatMessages(this.appSession.userId, this.equipeId)
      .pipe(finalize(() => abp.ui.clearBusy()))
      .subscribe((result) => {
        this.chatMensagens = result;
        this.cdr.detectChanges();
        this.eventRolarMensagensSubject.next();
        if (remetenteId && equipeId) {
          this.atualizarNotificacoes(remetenteId, equipeId)
        }
      });
  }

  atualizarUltimoRementente(mensagem: NewMessageDto) {
    this.getNotificacoesUsuario();
    let chat = this.conversas.find(x => x.equipeId == mensagem.equipeId);
    if (chat && mensagem.remetenteId) {
      chat.lastRemetenteId = mensagem.remetenteId;
      chat.dataHora = moment(mensagem.dataHora);
      chat.ultimaMensagem = mensagem.mensagem;

      this.conversas = [
        { ...chat },
        ...this.conversas.filter(x => x.equipeId != mensagem.equipeId)
      ];
      this.cdr.markForCheck();
    }
    this.cdr.detectChanges();
  }

  trackByEquipeId(index: number, item: any) {
    return item.equipeId;
  }
  

  getNotificacoesUsuario() {
    abp.ui.setBusy();
    this._notificacaoService
      .getNotificacoes()
      .pipe(finalize(() => abp.ui.clearBusy()))
      .subscribe((result) => {
        result.map((x) => {
          var notification: UserNotification = new UserNotification();
          notification.equipeId = x.equipeId;
          notification.remetenteId = x.remetenteId;
          this.notificacoes.push(notification);
        });
        this.cdr.detectChanges();
      });
  }

  getNewChatsUserId() {
    abp.ui.setBusy();
    this._chatService
      .getNewChats()
      .pipe(finalize(() => abp.ui.clearBusy()))
      .subscribe((result) => {
        this.novosChatsUserId = result;
      });
  }

  isNew(equipeId: string): boolean {
    return !this.novosChatsUserId.some((x) => x == equipeId);
  }

  temNotificacao(remetenteId: number, equipeId: string): boolean {
    if (remetenteId && equipeId) {
      return this.notificacoes.some((x) => x.remetenteId == remetenteId && x.equipeId == equipeId);
    }
  }

  getConversa() {
    return this.conversas.find(x => x.equipeId == this.equipeId);
  }

  atualizarNotificacoes(remetenteId: number, equipeId: string) {
    this._notificacaoService
      .atualizarNotificacaoByUserId(remetenteId, equipeId)
      .pipe()
      .subscribe(() => {
        this.notificacoes = this.notificacoes.filter(
          x => x.equipeId != equipeId
        );
        this.cdr.detectChanges();
      });
  }
}
